import { render, staticRenderFns } from "./Beneficiario.vue?vue&type=template&id=5eeb9107"
import script from "./Beneficiario.vue?vue&type=script&lang=js"
export * from "./Beneficiario.vue?vue&type=script&lang=js"
import style0 from "./Beneficiario.vue?vue&type=style&index=0&id=5eeb9107&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports